export type OperationalUnitCode = 'SKOFJA_LOKA' | 'LOGATEC';

export const OPERATIONAL_UNIT_LABELS: Record<OperationalUnitCode, string> = {
  SKOFJA_LOKA: 'Škofja Loka',
  LOGATEC: 'Logatec',
};

export const OPERATIONAL_UNIT_PATHS: Record<OperationalUnitCode, string> = {
  SKOFJA_LOKA: '/izdelki',
  LOGATEC: '/logatec',
};
